export default {
  smsRemain: {},
  smsCountHistory: { items: [], _links: {}, _meta: {} },
  smsCount: {}
}
